// src/components/visualizations/ChartPanel.vue

<template>
  <v-card elevation="12" outlined class="overflow">
    <v-card-title >
      <h4 class="gradient-text">Sector Statistics</h4>
      <v-spacer></v-spacer>
      <v-btn icon @click="downloadChart">
        <v-icon>mdi-download</v-icon>
      </v-btn>
    </v-card-title>

    <v-row no-gutters>
      <v-col cols="12">
        <v-tabs
          center-active
          v-model="activeTab"
          color="#a24187"
          slider-color="#a24187"
        >
          <v-tab>
            <v-icon color="#2E93fA">mdi-poll</v-icon> Bar
          </v-tab>
          <v-tab>
            <v-icon color="#2E93fA">mdi-chart-timeline-variant</v-icon>Line
          </v-tab>
          <v-tab>
            <v-icon color="#2E93fA">mdi-scatter-plot</v-icon> Scatter
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeTab">
          <v-tab-item v-for="type in chartTypes" :key="type">
            <apexchart
              ref="chart"
              width="100%"
              height="300"
              :type="type"
              :options="chartOptions"
              :series="series"
            ></apexchart>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ChartPanel',

  data() {
    return {
      activeTab: 0,
      chartTypes: ['bar', 'line', 'scatter'],
      title: 'Zone Statistics',
      dataTypeLabel: 'Zone-wise Statistics'
    };
  },

  computed: {
    ...mapGetters('geojson', ['filteredZoneStatistics']),

    series() {
        const stats = this.filteredZoneStatistics;
        if (!stats) return [];

        return [
            {
            name: 'Total Plots',
            data: Object.values(stats).map(stat => stat.total)
            },
            {
            name: 'Sold Plots',
            data: Object.values(stats).map(stat => stat.sold)
            },
            // {
            // name: 'Owners',
            // data: Object.values(stats).map(stat => stat.uniqueOwners)
            // }
        ];
    },

    chartOptions() {
        const stats = this.filteredZoneStatistics || {};
      return {
        chart: {
          stacked: false,
          toolbar: {
            show: true,
            tools: {
              download: false
            }
          }
        },
        colors: ['#2E93fA', '#66DA26', '#546E7A'],
        xaxis: {
            categories: Object.keys(stats),
          title: {
            text: 'Zones'
          }
        },
        yaxis: {
          title: {
            text: 'Count'
          }
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right'
        },
        stroke: {
          curve: 'smooth',
          width: 2
        },
        markers: {
          size: 5
        },
        tooltip: {
          shared: true,
          intersect: false
        }
      };
    }
  },

    methods: {
        downloadChart() {
            // Get the active chart reference
            const chartRef = this.$refs.chart[this.activeTab];
            if (!chartRef) return;

            // Get current timestamp for filename
            const timestamp = new Date().toISOString().split('T')[0];
            const chartType = this.chartTypes[this.activeTab];

            // Use ApexCharts built-in export functionality
            chartRef.chart.exports.exportToSVG().then((svg) => {
                const downloadLink = document.createElement('a');
                const blob = new Blob([svg], { type: 'image/svg+xml' });
                const url = window.URL.createObjectURL(blob);
                downloadLink.href = url;
                downloadLink.download = `zone-statistics-${chartType}-${timestamp}.svg`;
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
                window.URL.revokeObjectURL(url);
            });
        }
    }
};
</script>

<style scoped>
.inline {
  display: inline;
}
</style>